var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrollTo",on:{"click":function($event){return _vm.scrollTo()}}},[_c('img',{attrs:{"src":"svg/scroll-to.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }